window.B2BUtils = {
  calculateBonusKg({ grams, quantity }) {
    if (!window.B2B?.enabled) return 0;
    if (grams !== window.B2B.rule.allowedGrams) return 0;

    const totalKg = (grams * quantity) / 1000;
    const steps = Math.floor(totalKg / window.B2B.rule.stepKg);

    return steps * window.B2B.rule.bonusKg;
  },

  calculateCartBonus(cart) {
  if (!window.B2B?.enabled) {
    return { bonusKg: 0, eligibleKg: 0, breakdown: [] };
  }

  let totalEligibleKg = 0;
  let breakdown = [];

  cart.items.forEach(item => {
    const grams = item.grams;

    if (!grams) return;

    // 🔒 DOAR 1000g (toleranță pentru ambalaj)
    if (grams < 900) return;

    const kg = (grams * item.quantity) / 1000;
    totalEligibleKg += kg;

    const steps = Math.floor(kg / window.B2B.rule.stepKg);
    const bonusForItem = steps * window.B2B.rule.bonusKg;

    if (bonusForItem > 0) {
      breakdown.push({
        title: item.product_title,
        bonusKg: bonusForItem
      });
    }
  });

  const totalSteps = Math.floor(totalEligibleKg / window.B2B.rule.stepKg);
  const totalBonus = totalSteps * window.B2B.rule.bonusKg;

  return {
    bonusKg: totalBonus,
    eligibleKg: totalEligibleKg,
    breakdown
  };
}
};
